import { render, staticRenderFns } from "./tag-group.vue?vue&type=template&id=358d8b74&scoped=true&"
import script from "./tag-group.vue?vue&type=script&lang=ts&"
export * from "./tag-group.vue?vue&type=script&lang=ts&"
import style0 from "./tag-group.vue?vue&type=style&index=0&id=358d8b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d8b74",
  null
  
)

export default component.exports